<script setup>
import { useUserStore } from '~/store/user'

const { t } = useI18n()
const user = useUserStore()

const kycStatusInfo = computed(() => {
  return {
    0: {
      label: t('未认证'),
      class: 'text-textTertiary bg-border',
      icon: 'SvgoUserUnverified',
    },
    1: {
      label: t('初级认证'),
      class: 'text-green3 bg-border',
      icon: 'SvgoUserBasiccertification',
    },
    2: {
      label: t('高级认证'),
      class: 'text-blue3 bg-blue1',
      icon: 'SvgoUserAdvancedcertification',
    },
  }[user.info.kycStatus] ?? {}
})
</script>

<template>
  <div>
    <span
      class="inline-flex items-center justify-center relative px-1 pl-[14px] h-[20px] min-w-[44px] rounded  text-xs whitespace-nowrap"
      :class="kycStatusInfo.class"
    >
      <component :is="kycStatusInfo.icon" class="absolute -left-1.5 h-4 w-4" />
      {{ kycStatusInfo.label }}
    </span>
  </div>
</template>
